import { DebtType } from '@axo/shared/data-access/types';
import { useApplicationConditionalFilter } from '../../../../ConditionalWrappers/useApplicationConditionalFilter';
import { UnfilteredConditionalArray } from '../../../../ConditionalWrappers/types';
import { ApplicationConditionalContext } from '../../../../ConditionalWrappers/useApplicationConditionalContext';
import { MarketCountryCode } from '@axo/shared/types';

const unfilteredDebtTypeOptions = (
  [
    {
      value: DebtType.Housing,
      whitelist: [
        {
          marketCountry: [
            MarketCountryCode.Norway,
            MarketCountryCode.Finland,
            MarketCountryCode.Denmark,
          ],
        },
      ],
    },
    {
      value: DebtType.Student,
      whitelist: [
        {
          marketCountry: [
            MarketCountryCode.Norway,
            MarketCountryCode.Finland,
            MarketCountryCode.Denmark,
          ],
        },
      ],
    },
    {
      value: DebtType.CarMCBoat,
      whitelist: [
        {
          marketCountry: [MarketCountryCode.Norway],
        },
      ],
    },
    {
      value: DebtType.Personal,
      whitelist: [
        {
          marketCountry: [
            MarketCountryCode.Norway,
            MarketCountryCode.Finland,
            MarketCountryCode.Denmark,
          ],
        },
      ],
    },
    {
      value: DebtType.CreditCard,
      whitelist: [
        {
          marketCountry: [MarketCountryCode.Finland],
        },
      ],
    },
    {
      value: DebtType.Car,
      whitelist: [
        {
          marketCountry: [MarketCountryCode.Finland, MarketCountryCode.Denmark],
        },
      ],
    },
    {
      value: DebtType.Unspecified,
      whitelist: [
        {
          marketCountry: [MarketCountryCode.Sweden],
        },
      ],
    },
    {
      value: DebtType.Collection,
      whitelist: [
        {
          marketCountry: [MarketCountryCode.Denmark],
        },
      ],
    },
  ] satisfies UnfilteredConditionalArray<
    ApplicationConditionalContext,
    DebtType
  >
).map(({ value, ...rest }) => ({
  value: { value, label: value ? value : '-' },
  ...rest,
}));

export const useDebtTypeOptions = () =>
  useApplicationConditionalFilter(unfilteredDebtTypeOptions);
